export enum TrustPilotWidgetType {
  TEMPLATE_ID = '54ad5defc6454f065c28af8b',
  MINI_WIDGET_TEMPLATE_ID = '53aa8807dec7e10d38f59f32',
  WIDGET_TEMPLATE_ID = '5418052cfbfb950d88702476',
  MICRO_WIDGET_TEMPLATE_ID = '5419b6ffb0d04a076446a9af',
  WIDGET_MICRO_STAR_ID = '5419b732fbfb950b10de65e5'
}
